module.exports = __webpack_public_path__ + "ea4f87ad58693b75e2828a1da4b6c624.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/violin.png
// module id = 3219
// module chunks = 0